import { CommonModule } from '@angular/common';
import {Component, Input, ViewChild} from '@angular/core';
import { AccessRole, CustomTableHeader, DEFAULT_DATE_FORMAT, IColumns, IFormOptions, LoadingPanelService, LocalService, Utils,VisorComponent } from 'lib-base';
import { TableModule } from 'primeng/table';
import { IGetTramiteActividades, IGetUltimaActividadSeguimiento } from '../../../../shared/interfaces/tramite';
import { TramActividadService } from '../../../../services/tramActividad.service';
import { TagModule } from 'primeng/tag';
import { SkeletonModule } from 'primeng/skeleton';
import { TramSegDocumentoService } from '../../../../services/tramSegDocumento.service';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { FormRespuestasComponent } from '../../../../components/form-respuestas/form-respuestas.component';

@Component({
  selector: 'app-tramite-actividades',
  standalone: true,
  imports: [
    CommonModule, SkeletonModule, ButtonModule,
    TableModule, TagModule, TranslateModule,
    CustomTableHeader,VisorComponent, FormRespuestasComponent
  ],
  templateUrl: './tramite-actividades.component.html'
})
export class TramiteActividadesComponent {
  @Input() tramRegistroId !: number;
  @Input() estado !: string;
  @Input() observaciones !: string; //esto es para los rechazados

  isLoading: boolean = false;
  isLoadingSeguimiento: boolean = false;
  actividades: IGetTramiteActividades[] = []
  permiso = AccessRole;
  readonly defaultDateFormat = DEFAULT_DATE_FORMAT;
  columns !: IColumns[];

  ultimoSeguimientos?: IGetUltimaActividadSeguimiento[];

  readonly options: IFormOptions= {
      enableSubmit: false,
      isDesigner: false,
      viewAnswerMode: true
  };

  @ViewChild(VisorComponent) visorDialog!:VisorComponent;
  @ViewChild(FormRespuestasComponent) formRespuestas !: FormRespuestasComponent;
  
  constructor(
    private readonly _tas: TramActividadService, public ls: LocalService,
    private readonly _tsd: TramSegDocumentoService, private readonly _lps: LoadingPanelService
  ) {
    this.columns = [
      {
        id: 'actividad-column',
        field: 'actividad',
        header: 'Actividad',
        class: 'text-left',
        sort: false,
        columnFilter: false
      },
      {
        id: 'usuarioAsignado-column',
        field: 'usuarioAsignado',
        header: 'Usuario Asignado',
        class: 'text-left',
        sort: false,
        columnFilter: false
      },
      {
        id: 'estadoDescripcion-column',
        field: 'estadoDescripcion',
        header: 'Estado',
        class: 'text-left',
        sort: false,
        columnFilter: false
      },
    ];
  }

  ngOnInit(): void {
    this.getTramiteActividades();
    if (this.estaFinalizado) {
      this.getUltimaActividadSeguimiento();
    }
  }

  get estaFinalizado(): boolean {
    return this.estado === 'FINALIZADO';
  }

  get estaRechazado(): boolean {
    return this.estado === 'RECHAZADO';
  }

  getTramiteEstadoTagIcon(estado: string, usuarioAsignado: string): string {
    return Utils.getTramiteEstadoTagIcon(estado, usuarioAsignado);
  }

  getTramiteEstadoTagSeverity(estado: string, usuarioAsignado: string): 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast' {
    return Utils.getTramiteEstadoTagSeverity(estado, usuarioAsignado);
  }

  //#region API Calls
  getTramiteActividades() {
    if (!this.tramRegistroId) return;
    this.isLoading = true;
    this._tas.getTramiteActividades(this.tramRegistroId).subscribe({
      next: (data: IGetTramiteActividades[]) => {
        this.actividades = data;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      }
    });
  }

  getUltimaActividadSeguimiento() {
    if (!this.tramRegistroId) return;
    this.isLoadingSeguimiento = true;
    this._tas.getUltimaActividadSeguimiento(this.tramRegistroId).subscribe({
      next: (data: IGetUltimaActividadSeguimiento[]) => {
        this.ultimoSeguimientos = data;
        if (this.ultimoSeguimientos && this.ultimoSeguimientos.length > 0) {
          const seguimiento = this.ultimoSeguimientos[0];
          setTimeout(() => {
            this.formRespuestas.radicado = seguimiento.radicado;
            this.formRespuestas.loadForm(
              seguimiento.formularioId,
              seguimiento.formularioRespuesta
            );
          }, 1);
        }

      },
      complete: () => {
        this.isLoadingSeguimiento = false;
      }
    });
  }

  downloadFormFile(id: number, fileName: string) {
    this._lps.show(true);
    this._tsd.downloadFormFile(id).subscribe({
      next: (response: Blob) => {
        this._lps.hide();
        if (response.size > 0) {
          this.visorDialog?.showDialog(response);
        }
      }
    });
  }
  //#endregion API Calls


}
